import { CALL_API } from './../../middlewares/api';

const onChange = (key, value) => ({
  type: 'CHANGE_DATA_PRESENCA_CONTRATADO',
  value: { key, value }
});

const onCheckin = value => (dispatch, getState) => {
  if (getState().guiaInterativo.run) {
    return Promise.resolve(
      dispatch({
        type: 'CHECKIN_PRESENCA_CONTRATADO_SUCCESS_GUIA_INTERATIVO',
        value
      })
    );
  }

  return Promise.resolve(
    dispatch({
      //let data = getState().registroAcesso.data;
      //let { contratado, contratante } = data;
      /*
        Entrada:
            - contratante (id ou dados do contratante)
                se o contratante for novo, deve cadastrá-lo na base
            - contratado (id ou dados do contratado)
                se o contratado for novo, deve cadastrá-lo na base
            - registrante (id de quem registrou o check-in)
        Saída:
            - data/hora do check-in
            - contratante (id e text[apartamento - nome])
            - contratado (id e text[nome - funcao])
        */
      [CALL_API]: {
        type: 'CHECKIN_PRESENCA_CONTRATADO',
        endpoint: 'presencas',
        authenticated: true,
        config: {
          method: 'POST',
          redirect: 'follow',
          body: value
        },
        success: r => {
          dispatch(
            onRetrieveCheckin(value, r.response.headers.get('location'))
          );
          return r.json;
        }
      },
      value
    })
  );
};

const onRetrieveCheckin = (value, querystring) => ({
  [CALL_API]: {
    type: 'CHECKIN_PRESENCA_CONTRATADO_RETRIEVE',
    endpoint: 'presencas',
    authenticated: true,
    config: {
      method: 'GET',
      querystring
    }
  },
  value
});

const onCheckin_invalid = value => ({
  type: 'CHECKIN_PRESENCA_CONTRATADO_INVALID',
  value
});

const onCheckout_success = value => dispatch =>
  Promise.resolve(
    dispatch({
      type: 'CHECKOUT_PRESENCA_CONTRATADO_SUCCESS',
      value
    })
  );

const onCheckout_async = value => ({
  /*
    Entrada
        - contratado (id)
        - registrante (id de quem registrou o check-out)
    Saída
        - Status Code de remoção com sucesso
    */
  [CALL_API]: {
    type: 'CHECKOUT_PRESENCA_CONTRATADO',
    endpoint: 'presencas',
    authenticated: true,
    config: {
      method: 'PUT',
      querystring: { id: value.id }
    }
  },
  value
});

const onCheckout = value => {
  if (!value.id) {
    return onCheckout_success(value);
  }
  return onCheckout_async(value);
};

const onLoadPresencasIfNeeded = () => ({
  [CALL_API]: {
    type: 'LIST_PRESENCA_CONTRATADO',
    endpoint: 'presencas',
    authenticated: true,
    config: {
      method: 'GET',
      querystring: { type: 'abertos' }
    }
  }
});

const onLoadPresencas = () => (dispatch, getState) => {
  let {
    presencas: { fetching, errors }
  } = getState().registroAcesso;
  if (!fetching && !errors.length) {
    dispatch(onLoadPresencasIfNeeded());
  }
};

const onLoadContratantesIfNeeded = () => ({
  [CALL_API]: {
    type: 'LIST_CONTRATANTES',
    endpoint: 'contratantes',
    authenticated: true,
    config: {
      method: 'GET'
    }
  }
});

const onLoadContratantes = () => (dispatch, getState) => {
  let {
    contratantes: { fetching, errors }
  } = getState().registroAcesso;
  if (!fetching && !errors.length) {
    dispatch(onLoadContratantesIfNeeded());
  }
};

const onLoadContratadosIfNeeded = () => ({
  [CALL_API]: {
    type: 'LIST_CONTRATADOS',
    endpoint: 'contratados',
    authenticated: true,
    config: {
      method: 'GET'
    }
  }
});

const onLoadContratados = () => (dispatch, getState) => {
  let {
    contratados: { fetching, errors }
  } = getState().registroAcesso;
  if (!fetching && !errors.length) {
    dispatch(onLoadContratadosIfNeeded());
  }
};

const onLoadUltimosRegistrosAcesso = () => ({
  [CALL_API]: {
    type: 'LIST_ULTIMOS_REGISTROS_ACESSO',
    endpoint: 'presencas',
    authenticated: true,
    config: {
      method: 'GET',
      querystring: { type: 'recentes' }
    }
  }
});

export default {
  onChange,
  onCheckin,
  onCheckin_invalid,
  onCheckout,
  onLoadPresencas,
  onLoadContratantesIfNeeded,
  onLoadContratantes,
  onLoadContratadosIfNeeded,
  onLoadContratados,
  onLoadUltimosRegistrosAcesso
};



// WEBPACK FOOTER //
// ./src/modules/registroAcesso/actions.js